const angular = require('angular')
const jsSHA = require('jssha')
const get = require('lodash/get')
const find = require('lodash/find')
const filter = require('lodash/filter')
const xcmCipher = require('../infrastructure/xcm-cipher')
const aesjs = require('aes-js')

angular.module('hxphone.user', ['hxphone.infrastructure'])
  .factory('User', ['$q', 'WmsvrClient', '$cookies', 'LocalStorage', '$location',
    '$http', '$utils', '$window', 'HttpInterceptor',
    function ($q, WmsvrClient, $cookies, LocalStorage, $location,
      $http, $utils, $window, HttpInterceptor) {
      let CURRENT_USER = {}
      const accounts = getAccountsConfig()
      CURRENT_USER.config = accounts.currentUserId ? accounts[accounts.currentUserId] : {}

      function User() {
        this.config = {}
      }

      User.getCurrentUser = function () {
        if (!CURRENT_USER || !CURRENT_USER.sid) {
          CURRENT_USER = new User()
          CURRENT_USER.config = accounts.currentUserId ? accounts[accounts.currentUserId] : {}
          CURRENT_USER.wmsvrClient = new WmsvrClient()
        }
        // 每次都从 cookie 里面获取最新的 sid
        if (location.protocol === 'file:') {
          CURRENT_USER.sid = LocalStorage.getItem('Coremail.sid')
        } else {
          CURRENT_USER.sid = $cookies.get('Coremail.sid')
        }
        return CURRENT_USER
      }

      // 获取用户信息
      User.getConfig = function () {
        const user = User.getCurrentUser() || {}
        user.config = user.config || {}
        if (!user.config['$ajc']) {
          user.config['$ajc'] = {}
        }
        return user.config
      }

      User.updateSid = function (sid) {
        if (!sid) return

        CURRENT_USER.sid = sid
        if (location.protocol === 'file:') {
          LocalStorage.setItem('Coremail.sid', sid)
        } else {
          $cookies.remove('Coremail.sid')
          $cookies.put('Coremail.sid', sid, { path: '/' })
        }
      }

      User.getAttrs = function (sid) {
        const defer = $q.defer()
        let oUser = User.getCurrentUser()
        CURRENT_USER = CURRENT_USER || {}
        if (!(oUser.sid && oUser.wmsvrClient)) {
          oUser = User.newUser({})
          oUser.wmsvrClient = new WmsvrClient()
          CURRENT_USER = oUser
          User.updateSid(sid)
        }

        oUser.simpleCall({
          query: {
            func: 'user:getAttrs',
            sid: sid || oUser.sid
          },
          data: {
            optionalAttrIds: ['$ajc'],
            attrIds: [
              'email',
              'primary_email',
              'pref_quota',
              'true_name',
              'nick_name',
              'time_zone',
              'perm_func_netfolder',
              'signature_position'
            ]
          }
        }).then(function (data) {
          if (data['code'] == 'S_OK') {
            const userData = data['var']
            oUser.config = angular.extend(oUser.config || {}, userData)
            oUser.config.email = userData.email
            oUser.config.uid = userData.email
            CURRENT_USER = oUser
            saveUserData(oUser.config)
            defer.resolve(data['var'])
          } else {
            defer.reject(data)
          }
        }, function (error) {
          defer.reject(error)
          console.debug('user:getAttrs:error ' + JSON.stringify(error))
        })

        return defer.promise
      }

      // 获取公钥参数
      User.getPasswordKey = function () {
        const defer = $q.defer()
        User.getCurrentUser().simpleCall({
          query: {
            func: `user:getPasswordKey`,
            sid: User.getCurrentUser().sid
          }
        }).then(data => {
          if (data['code'] == 'S_OK') {
            defer.resolve(data['var'])
          } else defer.reject(data)
        }, function (error) {
          defer.reject(error)
        })
        return defer.promise
      }

      // 判断是否开启第三方网盘
      User.getXnfConfig = function () {
        const defer = $q.defer()
        User.getCurrentUser().simpleCall({
          query: {
            func: `xnf:getConfig`,
            sid: User.getCurrentUser().sid
          }
        }).then(data => {
          if (data['code'] == 'S_OK') {
            if ((Object.keys(data['var'].engines)).length) defer.resolve(true)
          } else defer.reject(false)
        }, function () {
          defer.reject(false)
        })
        return defer.promise
      }

      User.getGlobalOptions = function () {
        const urlPrefix = User.getCurrentUser().wmsvrClient.getWmsvrURLPrefix()
        const options = {
          method: 'POST',
          url: `${urlPrefix}/s/json/?func=global:options`,
          headers: { 'Content-Type': 'application/x-cm-json' },
          responseType: 'arraybuffer',
          data: null // encrypt like fromBytes(xcmCipher.encrypt(toBytes(data).buffer))
        }
        return $http(options).then(res => {
          console.log('getGlobalOptions success!')
          const result = res.data
          // eslint-disable-next-line no-control-regex
          const text = b => aesjs.utils.utf8.fromBytes(b).replace(/\x00+$/, '')
          const dResult = JSON.parse(text(xcmCipher.decrypt(new Uint8Array(result))))
          console.log('getGlobalOptions-decrypt-success!')
          if (dResult.code !== 'S_OK') return $q.reject(dResult)

          return dResult.var || {}
        })
      }

      User.newUser = function (oData) {
        const user = new User()
        user.config = oData
        return user
      }

      // 获取共享邮箱账号
      User.getSharedMailAccounts = function() {
        const oUser = User.getCurrentUser()
        return oUser.simpleCall({
          query: {
            func: 'mbox:listSharedAccessMbox'
          },
          data: {
            showHidden: true,
            stats: true
          }
        }).then(res => {
          if (res.code !== 'S_OK') return $q.reject(res)

          const visibleMailboxList = res.var || []
          User.updateMailboxAccounts({visibleMailboxList: visibleMailboxList})
          return visibleMailboxList
        })
      }

      // 获取邮箱账号列表（含共享邮箱）
      User.getMailboxAccounts = function () {
        const config = User.getConfig()
        return config.mailboxAccounts || {}
      }

      // 更新共享邮箱数据
      User.updateMailboxAccounts = function (obj, isForce) {
        const config = User.getConfig()
        const mainAccount = { email: config.email, _access: -1 }
        // obj > localstorage > init, localstorage需要重新登录才会重置
        const mailboxAccounts = angular.extend(
          {
            mainAccount: mainAccount, // 主账号
            selectedAccount: mainAccount, // 当前选中的账号
            visibleMailboxList: [] // 共享给我的邮箱
          },
          isForce ? {} : config.mailboxAccounts,
          obj
        )
        mailboxAccounts.visibleMailboxList = filter(mailboxAccounts.visibleMailboxList, item => {
          if (item.hidden) return false

          if (!item.send && !item.rw) item._access = 0 // 只读
          else if (item.send && item.rw) item._access = 1 // 代理发送
          else if (item.send && !item.rw) item._access = 2 // 代表发送

          return true
        })
        config.mailboxAccounts = mailboxAccounts
        saveUserData(config)
        return mailboxAccounts
      }

      // 获取当前选中邮箱账号的特征属性mboxa，空字符串标识主账号
      User.getSelectedAccountSymbol = function () {
        const mailboxAccounts = User.getMailboxAccounts()
        const mboxId = mailboxAccounts.selectedAccount && mailboxAccounts.selectedAccount.id
        return mboxId ? `@${mboxId}` : ''
      }

      /**
       * @description 获取当前选中邮箱账号的权限类型（主账号或共享账号）
       * @returns {Number}  -1(主账号) 0(只读) 1(代理) 2(代表)
       */
      User.getSelectedAccountAccess = function () {
        const selectedAccount = User.getMailboxAccounts().selectedAccount
        return selectedAccount ? selectedAccount._access : -1
      }

      // 获取指定id对应的账号权限类型
      User.getAccountAccessById = function (id) {
        const mailboxAccounts = User.getMailboxAccounts()
        const visibleAccounts = mailboxAccounts.visibleMailboxList || []
        const tempAccount = find(visibleAccounts, i => i.id === id)
        return tempAccount ? tempAccount._access : undefined
      }

      User.prototype.save = function () {
        saveUserData(this.config)
      }

      User.prototype.login = function (oParam) {
        const self = this
        const accounts = getAccountsConfig()
        // 登录时候的email是uid，即不一定带有完整的邮件地址
        let email = self.config.email
        email += ~email.indexOf('@') ? '' : '@'
        let currentUserId = find(Object.keys(accounts), item => item.indexOf(email) === 0)
        currentUserId = currentUserId || self.config.email
        const oUserConfig = accounts[currentUserId]
        self.config = oUserConfig || self.config
        self.wmsvrClient = new WmsvrClient()
        const options = {
          uid: oParam.uid,
          password: oParam.password,
          locale: oParam.locale,
          ssl: oParam.ssl,
          verifyCode: oParam.verifyCode,
          dynamicPwd: oParam.dynamicPwd,
          verifyCellCode: oParam.verifyCellCode,
          authDevice: oParam.authDevice,
          supportDynamicPwd: true,
          supportSms: true,
          device: getDeviceInfo()
        }

        const tokenInfo = self.getTokenInfo()
        if (tokenInfo.accessToken) {
          angular.extend(options, tokenInfo)
          angular.extend(self.config, tokenInfo)
        }

        return self.wmsvrClient.simpleCall({
          query: {
            func: 'user:login',
            sid: (oParam.sid || self.sid)
          },
          data: options
        }).then(data => {
          if (data.code !== 'S_OK') return $q.reject({data: data})
          if (data.var.needBindTowFactorAuth) return $q.reject({data: { code: 'FA_NEED_BIND_TOW_FACTOR_AUTH' }})

          const resultVar = data.var
          console.log('login:result: ' + JSON.stringify(resultVar))
          const sid = resultVar.sid

          self.config.logined = true
          self.config.email = oParam.uid
          self.config.locale = oParam.locale
          if (resultVar.accessToken) {
            self.config.accessToken = resultVar.accessToken
            self.config.accessSecret = resultVar.accessSecret
            self.config.nonce = resultVar.nonce
          }
          if (resultVar['nonce']) {
            self.config.nonce = resultVar['nonce']
          }
          CURRENT_USER = self
          saveUserData(self.config)
          return sid
        }).finally(_ => {
          // 清除二次验证的配置项
          self.config.hasSecondAuthenticated = false
        }).catch(reason => {
          const sid = get(reason, 'data.var.sid')
          const smsaddr = get(reason, 'data.var.smsaddr')
          if (sid) {
            localStorage.setItem('cellNumber', smsaddr || '')
            self.sid = sid
          }
          saveUserData(self.config)
          return $q.reject(reason)
        })
      }

      User.prototype.simpleCall = function (options) {
        const self = this
        const deferred = $q.defer()
        const query = options.query || {}
        query.sid = self.sid
        options.query = query

        this.wmsvrClient.simpleCall(options).then(
          function (data) {
            deferred.resolve(data)
          },
          function (reason) {
            console.log('error: ' + JSON.stringify(reason))
            if (HttpInterceptor.response) {
              HttpInterceptor.response(self, options, reason).then(function (data) {
                deferred.resolve(data)
              }, function (error) {
                deferred.reject(error)
              })
            } else {
              deferred.reject(reason.data)
            }
          }
        )
        return deferred.promise
      }

      User.prototype.logout = function () {
        const self = this
        const deferred = $q.defer()
        this.wmsvrClient.simpleCall({
          query: {
            func: 'user:logout',
            sid: User.getCurrentUser().sid
          }
        }).then(function (data) {
          deferred.resolve(data)
        }, function (reason) {
          deferred.reject(reason)
        }).finally(function () {
          self.clearConfig()
        })
        return deferred.promise
      }

      User.prototype.clearConfig = function () {
        const self = this
        delete self.config.password
        delete self.config.netfolder

        self.config.logined = false
        saveUserData(self.config)
      }

      User.prototype.getVerifyCodeImgSrc = function () {
        const self = this
        return self.wmsvrClient.getRequestURL({
          query: {
            func: 'user:generateVerifyCodeImage',
            sid: self.sid,
            category: 'login',
            rand: Math.floor(Math.random() * 1000) + 1
          }
        })
      }

      User.prototype.getTempSession = function () {
        const self = this
        const deferred = $q.defer()

        self.wmsvrClient.simpleCall({
          query: {
            func: 'user:getTempSession'
          }
        }).then(function (data) {
          if (data.code === 'S_OK') {
            self.sid = data['var']['sid']
            deferred.resolve(self.sid)
          } else {
            deferred.reject(data)
          }
        }, function (data) {
          deferred.reject(data)
        })

        return deferred.promise
      }

      // 用户二次验证
      User.prototype.secondAuthenticate = function (password) {
        const self = this
        const deferred = $q.defer()
        const options = {
          password: password
        }

        self.simpleCall({
          query: {
            func: 'user:authenticate2',
            sid: User.getCurrentUser().sid
          },
          data: options
        }).then(function (data) {
          if (data.code === 'S_OK') {
            self.config.hasSecondAuthenticated = true
            deferred.resolve(true)
          }
        }, function (data) {
          deferred.resolve(false)
        })
        return deferred.promise
      }

      function getUserStorageConfig(user) {
        const accountStorage = LocalStorage.getItem('account')
        const userId = accountStorage.currentUserId || user.config.email
        return accountStorage[userId]
      }

      User.prototype.getTokenInfo = function () {
        const self = this
        const config = (self.config && self.config.accessToken) ? self.config : (getUserStorageConfig(self) || {})
        // accessSecret在存储里面被删除后，login带上accessToken就会一直无法返回新的accessSecret
        if (!config.accessSecret) return {}

        let shaObj = new jsSHA('SHA-1', 'TEXT') //eslint-disable-line
        const curTime = (Math.round(new Date().getTime() / 1000.0)).toString()
        const signature = 'accessToken=' + encodeURIComponent(config.accessToken) +
          '&nonce=' + encodeURIComponent(config.nonce) +
          '&timestamp=' + encodeURIComponent(curTime) +
          '&secret=' + encodeURIComponent(config.accessSecret)

        shaObj.update(signature)
        const b64Signature = shaObj.getHash('B64')
        return {
          accessToken: config.accessToken,
          nonce: config.nonce,
          timestamp: curTime,
          signature: b64Signature
        }
      }

      function getDeviceInfo() {
        let model, friendlyName
        const unknown = 'na' // 未知设备名称
        const detector = $utils.$detector
        const os = detector.os || {}
        const device = detector.device || {}
        const browser = detector.browser || {}
        const timestamp = (new Date()).getTime()

        if (device.name == unknown || !device.name) {
          model = os.name
        } else {
          model = device.name
        }

        // 设备名称使用浏览器 + 版本号
        if (browser.name == unknown || !browser.name) {
          friendlyName = unknown
        } else {
          friendlyName = browser.name
          if (browser.version !== '-1') {
            friendlyName += (' ' + browser.version)
          }
        }

        return {
          'uuid': 'hxphone_' + timestamp,
          'model': model,
          'os': os.name,
          'imie': 'hxphone_' + timestamp,
          'friendlyName': friendlyName, // 设备名称
          'osLanguage': navigator.language,
          'deviceType': 'Hxphone'
        }
      }

      function getAccountsConfig() {
        return LocalStorage.getItem('account')
      }

      function saveUserData(oUserConfig) {
        // 保持与webmail一致，没有true_name的发件人无需截取邮件地址前缀作为true_name
        // if (!oUserConfig.true_name) {
        //   oUserConfig.true_name = $utils.$email.getUid(oUserConfig.email)
        // }
        if (!oUserConfig.primary_email) {
          oUserConfig.primary_email = oUserConfig.email
        }
        const accounts = {}
        delete oUserConfig.password
        accounts[oUserConfig.email] = oUserConfig
        accounts.currentUserId = oUserConfig.email
        LocalStorage.setItem('account', accounts)
        return accounts
      }

      // 获取当前用户号的cToken
      User.prototype.getCToken = function () {
        const urlPrefix = this.wmsvrClient.getWmsvrURLPrefix()
        return $http.get(`${urlPrefix}/cmcu_addon/generateToken.jsp`, {params: {sid: this.sid}})
          .then(res => {
            const token = res.data.result
            if (!token) {
              res.code = res.errorCode
              res.message = res.errorMsg
              return $q.reject(res)
            }

            return token.split(':')[1]
          })
      }

      return User
    }
  ])



// WEBPACK FOOTER //
// ./src/js/user/User.js